var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[_c('invite-view',{attrs:{"params":this.$route.params},on:{"save":_vm.saveInvite}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }